import { gql } from '@apollo/client'

export const GET_ALL_REASONS_REJECT_CANCELLATION = gql`
  query GetAllRequestRejectedCancellation(
    $limit: Int
    $offset: Int
    $searchQuery: String
  ) {
    getAllRequestRejectedCancellation(
      limit: $limit
      offset: $offset
      searchQuery: $searchQuery
    ) {
      count
      rows {
        id
        reason
        description
        category
        type
        is_active
      }
    }
  }
`
